import(/* webpackMode: "eager" */ "/workspace/libs/i18n/src/lib/client.ts");
;
import(/* webpackMode: "eager" */ "/workspace/libs/i18n/src/lib/SafeI18nProvider.tsx");
